// extracted by mini-css-extract-plugin
export default {"mb5":"WishList_mb5__-GaHu","textHover":"WishList_textHover__2YOyS","fs9":"WishList_fs9__99QHl","fs8":"WishList_fs8__voWX4"};